module.exports = __webpack_public_path__ + "img/condor1.17c9fe6a.png";